<script>
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getStr, isDirectionRTL, globalCurrencyTag } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import { showOtherSellerModal, pdpSellerInfoData } from '../../store/pdp_store.js';

  const { lang } = getAppConfig();
  const isRTL = isDirectionRTL();

  let otherSellersCount = $pdpSellerInfoData?.otherSellersCount;
  let otherSellersLowestPrice = $pdpSellerInfoData?.otherSellersLowestPrice;

  const openOtherSellersModal = () => {
    showOtherSellerModal.set(true);
  };
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="mp_seller-info-wrapper" class:rtl={isRTL} on:click={openOtherSellersModal}>
  <div class="title-wrapper">
    <div class="mp_primary-title">
      <Icon class="primary-icon" type="primary" glyph="icon-price_match" mobileSize={40} desktopSize={40} />
      <span><Text key="extra.marketplace.pdp.seller.other.text" /></span>
    </div>
  </div>
  <section class="mp_seller-details">
    <div class="mp-seller-name">
      {@html getStr('extra.marketplace.pdp.seller.offer.starts.from', [
        otherSellersCount,
        globalCurrencyTag,
        otherSellersLowestPrice,
      ])}
    </div>
    <div class="mp-seller-action">
      <Icon type="font" glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'} mobileSize={26} desktopSize={26} />
    </div>
  </section>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .mp_seller-info-wrapper {
    background-color: $neutral-light-04;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px 14px 24px;
    margin-top: 8px;
    @include responsive {
      border-radius: 8px;
      padding: 10px;
    }
    .title-wrapper {
      color: $neutral-dark-01;
      display: flex;
      justify-content: space-between;
      .mp_primary-title {
        align-items: center;
        display: flex;
        font-size: 18px;
        font-weight: 700;
        line-height: 20px;
        gap: 8px;
      }
    }
    .mp_seller-details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $primary-white;
      border-radius: 12px;
      gap: 8px;
      padding: 13px 25px 13px 13px;
      .mp-seller-name {
        font-size: 16px;
        line-height: 26px;
        @include responsive {
          font-size: 14px;
        }
        strong {
          font-weight: 700;
        }
      }
      .mp-seller-action {
        color: $icon-only-icon-blue;
        line-height: 0;
      }
    }
  }
</style>
